// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PED_VEN_MODALIDADE_VND = {
  VendaDiretaComum: 'PED_VEN_MODALIDADE_VND1',
  VendaCompartilhadaSplit: 'PED_VEN_MODALIDADE_VND2',
  EstruturadaSDRCloser: 'PED_VEN_MODALIDADE_VND3',
  VendaIndiretaCanalBroker: 'PED_VEN_MODALIDADE_VND4',
  Autoatendimento: 'PED_VEN_MODALIDADE_VND5',
  VendaRepresentada: 'PED_VEN_MODALIDADE_VND6',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PED_VEN_MODALIDADE_VND1: 1,
    PED_VEN_MODALIDADE_VND2: 2,
    PED_VEN_MODALIDADE_VND3: 3,
    PED_VEN_MODALIDADE_VND4: 4,
    PED_VEN_MODALIDADE_VND5: 5,
    PED_VEN_MODALIDADE_VND6: 6
  }
}
